import { useEffect } from 'react';
import { setHooryWidgetHidersCount } from 'appRedux/actions';
import { useAppDispatch, useAppSelector } from 'appRedux/hooks';

type UseHooryWidgetHiderCountProps = {
  hiderType: 'modal' | 'drawer' | 'confirmPopup';
  open?: boolean;
};

export const useHooryWidgetHiderCount = ({
  hiderType,
  open
}: UseHooryWidgetHiderCountProps) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!open) return;
    dispatch(setHooryWidgetHidersCount({ hiderType, operation: 'increase' }));
    return () => {
      dispatch(setHooryWidgetHidersCount({ hiderType, operation: 'decrease' }));
    };
  }, [open]);
};

export const useHideHooryWidget = () => {
  const { modal, confirmPopup, drawer } = useAppSelector(
    ({ global }) => global
  ).hooryWidgetHidersCount;
  const shouldHide = modal > 0 || confirmPopup > 0 || drawer > 0;

  useEffect(() => {
    const hooryWidget = window.$hoory;
    if (!hooryWidget) return;
    try {
      if (shouldHide) {
        hooryWidget.toggleBubbleVisibility('hide');
      } else {
        hooryWidget.toggleBubbleVisibility('show');
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(`Error while interacting with hoory widget: ${e}`);
    }
  }, [shouldHide]);
};
